<template>
  <v-container wrap class="text-center">
    <circles-loader v-if="!error"></circles-loader>
    <div v-if="error">
      <h2>{{ $t('message.error_generic') }}</h2>
      <v-btn @click="navigateTo({ name: 'products' })" color="secondary">
        {{ $t('message.back') }}
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { Environment } from "@/services/Environment";
import CirclesLoader from "@/components/displays/CirclesLoader.vue";
import Api from "@/services/Api";

export default {
  data() {
    return {
      stripeAccountId: null,
      sessionId: this.$route.params.sessionId,
      stripePublishableKey: null,
      error: false
    };
  },
  components: {
    CirclesLoader
  },
  created() {
    Api().get('admintablet/academy/' + this.$store.state.tabletManagedAcademy)
      .then(response => {
        const data = response.data;
        if (data) {
          this.stripeAccountId = data.stripeAccountId;
          if (this.sessionId && this.stripeAccountId) {
            //console.log('Loading with with session: ', this.sessionId);
            this.checkout(this.sessionId);
          } else {
            this.error = true;
          }
        }
      }).catch((err) => {
        if (err) {
          console.log('Error processing checkout: ', err);
          this.error = true;
        }
      });
  },
  watch: {},
  methods: {
    checkout(sessionId) {
      this.stripePublishableKey = Environment.get("VUE_APP_STRIPE_PUBLISHABLE_KEY");
      console.log('this.stripePublishableKey: ', this.stripePublishableKey);
      if (this.stripeAccountId) {
        /*eslint-disable no-undef*/
        var stripe = Stripe(this.stripePublishableKey, {
          stripeAccount: this.stripeAccountId
        });
        /*eslint-disable no-undef*/
        stripe.redirectToCheckout({
          sessionId: sessionId
        });
      } else {
        console.log('No stripe accountId!');
        this.error = true;
      }
    }
  }
};
</script>

<style scoped></style>
